import React from 'react';
import css from "../Profile.module.scss";
import infinite from '../../../../images/infinite.svg'
import darkInfinite from '../../../../images/dark_infinite.svg'
import dots from '../../../../images/submenu.svg'
import share from '../../../../images/submenu_share.svg'
import item3 from "../../../../images/edit.svg";
import item4 from "../../../../images/trash.svg";
import {useTheme} from "../../../../App";
import licensePlaceholder from '../../../../images/license-placeholder.png'
import {useTranslation} from "react-i18next";

const License = ({license, onDelete, setEditItem, setSendItem, isDark}) => {
  const {license_type, name, country, front_image, back_image, school_name, instructor_name,
    issue_date, license_number, license_system, issuer_name, expiry_date} = license
  const {t} = useTranslation()
  return (
    <div className={`${css.license} ${isDark && css.license__dark}`}>
      <div className={css.license__add}>
        <button className={'submenuTrig'}>
          <img src={dots} alt=""/>
        </button>
        <div className={`submenu ${css.license__submenu} ${isDark && 'submenu__dark'}`}>
          <button onClick={() => setSendItem({...license})} className={'submenuItem'}>
            <img src={share} alt="" className={'submenuIcon'}/>
            {t('send')}
          </button>
          <button onClick={() => setEditItem({...license})} className={'submenuItem'}>
            <img src={item3} alt="" className={'submenuIcon'}/>
            {t('edit')}
          </button>
          <button onClick={onDelete} className={'submenuItem'}>
            <img src={item4} alt="" className={'submenuIcon'}/>
            {t('delete')}
          </button>
        </div>
      </div>
      <div className={css.license__imgWrapper}>
        <img src={back_image ? `data:image/png;base64,${back_image}` : licensePlaceholder}
             alt="" className={css.license__img}/>
        <img src={front_image ? `data:image/png;base64,${front_image}` : licensePlaceholder}
             alt="" className={css.license__img}/>
      </div>
      <div className={css.license__info}>
        <p className={css.name}>{license_type?.name ?? name}</p>
        <div className={css.info__data}>
          <div className={`${css.info__col} ${license_system.name.length > 20 ? 'width-100' : 'w-48'}`}>
            <p className={css.info__label}>{t('issuedBy')}:</p>
            <p className={css.info__value}>{license_system.name}</p>
          </div>
          {country && <div className={`${css.info__col} w-48`}>
            <p className={css.info__label}>{t('country')}:</p>
            <p className={css.info__value}>{country.name}</p>
          </div>}
          {issuer_name && <div className={`${css.info__col} w-48`}>
            <p className={css.info__label}>{t('organization')}</p>
            <p className={css.info__value}>{issuer_name}</p>
          </div>}
          <div className={`${css.info__col} w-48`}>
            <p className={css.info__label}>{t('licenseNumber')}:</p>
            <p className={css.info__value}>{license_number}</p>
          </div>
          {school_name && <div className={`${css.info__col} w-48`}>
            <p className={css.info__label}>{t('sailSchool')}:</p>
            <p className={css.info__value}>{school_name}</p>
          </div>}
          {instructor_name && <div className={`${css.info__col} w-48`}>
            <p className={css.info__label}>{t('instructor')}:</p>
            <p className={css.info__value}>{instructor_name}</p>
          </div>}
          <div className={`${css.info__col} w-48`}>
            <p className={css.info__label}>{t('issueDate')}:</p>
            <p className={css.info__value}>{issue_date}</p>
          </div>
          <div className={`${css.info__col} w-48`}>
            <p className={css.info__label}>{t('validTill')}:</p>
            {!!expiry_date ? <p className={css.info__value}>{expiry_date}</p>
            : <img src={isDark ? darkInfinite : infinite} alt=""/>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(License);
